import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class PovzalohyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}
}

export const apiProvider = new PovzalohyApi();
